import { createSlice } from '@reduxjs/toolkit';
import { saveState } from '../../localStorage';

export const accessGate = createSlice({
  name: 'accessGate',
  initialState: {
    showAccessGate: false,
    invalidAccessKey: false,
    gateChecked: false,
  },
  reducers: {
    setShowAccessGate: (state, action) => {
      state.showAccessGate = action.payload;
      saveState('accessGate', state);
    },
    setInvalidAccessKey: (state, action) => {
      state.invalidAccessKey = action.payload;
      saveState('accessGate', state);
    },
    setGateChecked: (state, action) => {
      state.gateChecked = action.payload;
      saveState('accessGate', state);
    },
  },
});

export const { setShowAccessGate, setInvalidAccessKey, setGateChecked } = accessGate.actions;

export default accessGate.reducer;
